import React from 'react';
import moment from 'moment';

import store from '@tvguide/store';

import { getOnAirClass, getOnDemandIcon } from '@helpers';

const locationHost = window.location.host;
let isFreely = false;
if (locationHost.indexOf('freely') > -1) {
  isFreely = true;
}

const nid = store.getState().ux.nid;
const Program = ({
  p,
  sid,
  currentTime,
  pixelRatio,
  handleClick,
  isActive,
  leftOffset,
  isDST,
  accessibility,
  highlight,
}) => {
  const activeAccessibilities = accessibility.filter(el => el.value);
  let highlighted = true;

  if (activeAccessibilities.length > 0) {
    try {
      highlighted = activeAccessibilities.some(a => {
        return p.events[0].access_services.tv[a.propertyName];
      });
    } catch (e) {
      highlighted = false;
    }
  }

  return (
    <li
      className={`tvg-grid__program ${
        highlighted ? '' : 'tvg-grid__program--hide'
      } ${getOnAirClass(currentTime, p.start_time, p.duration)} ${
        isActive ? 'is-active' : ''
      }`}
      style={{
        width: `${moment.duration(p.duration).asMinutes() * pixelRatio}px`,
        left: `${leftOffset * pixelRatio}px`,
      }}
      onClick={() => handleClick(sid, p.uuid, p.program_id)}
    >
      <div className="tvg-grid__program__inner">
        {highlight && highlight.value && (
          <div
            className="tvg-grid__program__highlight"
            style={{
              backgroundColor: isFreely
                ? highlight.freelyColor
                : highlight.color,
            }}
          ></div>
        )}
        <span className="tvg-grid__program__start-time">
          {getOnDemandIcon(currentTime, p, nid, sid)}
          {moment
            .utc(p.start_time)
            .add(+isDST, 'hour')
            .format('h:mma')}
        </span>
        <span
          className="tvg-grid__program__title"
          dangerouslySetInnerHTML={{ __html: p.main_title }}
        />
      </div>
    </li>
  );
};

export default Program;
